import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { schema } from './character-class.yup';
import {
    updateCharacterClassCardApi as updateCardApi,
    showCharacterClassCardApi as showCardApi,
    clearEditedCharacterClassCard,
} from './characterClassCardSlice';
import { FORM_GROUPS } from './constants.character-class';
import FormTabManager from '~/pages/CardSaga/components/FormTabManager.jsx';
import { FormTabProvider } from '~/pages/CardSaga/components/providers/FormTabProvider';
import CharacterClassSkin from './components/CharacterClassSkin/CharacterClassSkin';
import uploadImage from '~/api/uploadImage';

function CharacterClassUpdate() {
    const { id } = useParams();
    const { editedModel: initialValues, allPictures } = useSelector((state) => state.cardSaga.characterClassCard);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formGroups = [...FORM_GROUPS]; //as you use formGroups.shift() (which mutate the original `formGroups`) at `FormTabProvider.jsx` => `formGroups` must be cloned here else so that it is not be shift() again on next visit.
    const cardInformation = formGroups.shift();

    const formSubmit = async (values, formikBag) => {
        await uploadImage(values, allPictures, 'character_classes');
        for(let picture of allPictures) {
            delete values[picture];
        }
        console.log(">>>>>>>>", values);
        dispatch(updateCardApi({ navigate, id, values, formikBag }));
    };

    useEffect(() => {
        dispatch(showCardApi({ navigate, id }));

        return () => dispatch(clearEditedCharacterClassCard());
    }, []);

    return (
        <>
            <FormTabProvider
                initialValues={initialValues}
                schema={() => schema(true)}
                formGroups={formGroups}
                cardInformation={cardInformation}
                allPictures={allPictures}
                displayFormikState={false}
            >
                <FormTabManager formSubmit={formSubmit} />
            </FormTabProvider>

            {/* <CharacterClassSkin /> */}
        </>
    );
}

export default CharacterClassUpdate;
